export const SUPPORT_EMAIL = process.env.VUE_APP_SUPPORT_EMAIL || 'help@huntica.works';
export const CONFIDENTIAL_URL = `${process.env.VUE_APP_FRONT_URL}/confidential` || 'https://app.huntica.works/confidential';
export const RULES_URL = `${process.env.VUE_APP_FRONT_URL}/rules` || 'https://app.huntica.works/rules';
export const APP_DOMAIN = process.env.VUE_APP_FRONT_URL || 'huntica.works';

export const shouldShowHHIntegration = () => {
  const frontUrl = process.env.VUE_APP_FRONT_URL || '';
  const isLocalhost = frontUrl.includes('localhost');
  const isRuOrOnline = (frontUrl.includes('.ru') || frontUrl.includes('.online')) && !frontUrl.includes('.works');
  return isLocalhost || isRuOrOnline;
};
